import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  deBaseAFechaLocal,
  manejadorDeRespuesta,
} from "../../../../utils/Tools.js";
import { reservasAPI, toolsAPI } from "../../../../utils/funcionesAPI.js";
import { toast, ToastContainer } from "react-toastify";
import get from "../../../../utils/get.js";
//import { productosAPI } from '../../../../utils/funcionesAPI'
//import {manejadorDeRespuesta} from '../../../../utils/Tools'
//import {RUTA_ITINERARIO} from '../../../../utils/rutasFijas'
//import { toast } from 'react-toastify'

const EdicionPasajero = (props) => {
  const { pasajero, numeroReserva, pasajeros, estado } = props;
  const [disabled, setDisabled] = useState(true);
  const [pasajeroNuevo, setPasajeroNuevo] = useState(pasajero);
  const [tiposDocumento, setTiposDocumento] = useState([]);

  const token = sessionStorage.getItem("token");
  const tipoCliente = sessionStorage.getItem("tipoCliente");

  const hadleClickCancelar = () => {
    setDisabled(true);
    setPasajeroNuevo(pasajero);
  };

  const hadleClickEditar = (pax) => {
    setDisabled(false);
    setPasajeroNuevo(pax);

    const data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDocumento(respuesta.data);
    });
  };

  const handleInputChange = (e) => {
    if (e.target.name === "documento" || e.target.name === "telefono") {
      if (!/^\d*$/.test(e.target.value)) {
        return false;
      }
    }

    setPasajeroNuevo({
      ...pasajeroNuevo,
      [e.target.name]: e.target.value,
    });
  };

  const handleTipoDocumentoChange = (e) => {
    //let idTipoDocumento = e.target.value;
    const tipoDocumentoElegido = tiposDocumento.find(
      (tip) => tip.idTipoDocumento === e.target.value,
    );

    setPasajeroNuevo({
      ...pasajeroNuevo,
      tipoDocumento: tipoDocumentoElegido,
    });
  };

  const hadleClickGuardar = (pax, documentoOriginal) => {
    const result = validarDatosCompletos(pax);

    if (!result) {
      alert("Debe completar todos los campos del pasajero");
      return;
    }

    if (typeof pax.tipoDocumento === "string") {
      pax.tipoDocumento = tiposDocumento.find(
        (tip) => tip.sigla === pax.tipoDocumento,
      );
    }

    if (!documentoEsValido(pasajeros, pax.documento)) {
      alert("Ya hay otro pasajero con el mismo numero de documento");
      return;
    }

    let data = JSON.stringify({
      peticion: "actualizarPasajero",
      token,
      pasajero: { ...pax, fechaNacimiento: pax.fechaNacimientoISO },
      documentoOriginal,
      numeroReserva,
    });

    reservasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        toast.success(respuesta.data, {
          position: toast.POSITION.BOTTOM_CENTER,
          onClose: () => window.location.reload(),
        });
    });
  };

  const traerTipoDoc = () => {
    if (pasajeroNuevo.tipoDocumento)
      return pasajeroNuevo.tipoDocumento.idTipoDocumento;
  };

  const validarDatosCompletos = (pax) => {
    const required = [
      "nombre",
      "apellido",
      "telefono",
      "fechaNacimiento",
      "documento",
      "tipoDocumento",
    ];

    const valid = required.every(
      (prop) =>
        Object.hasOwn(pax, prop) && pax[prop] !== "" && pax[prop] != null,
    );

    return valid;
  };

  const documentoEsValido = (pasajeros, documento) => {
    const cantidad = pasajeros.filter((p) => p.documento === documento).length;
    return cantidad < 1;
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          onChange={handleInputChange}
          name="nombre"
          value={pasajeroNuevo.nombre}
          placeholder="Nombre"
          disabled={disabled}
          style={{
            width: "90px",
          }}
        />
      </td>
      <td>
        <input
          type="text"
          onChange={handleInputChange}
          name="apellido"
          value={pasajeroNuevo.apellido}
          placeholder="Apellido"
          disabled={disabled}
          style={{
            width: "90px",
          }}
        />
      </td>
      <td>
        {disabled &&
          get(
            pasajeroNuevo,
            "tipoDocumento.sigla",
            pasajeroNuevo.tipoDocumento,
          )}
        {!disabled && (
          <select
            name="tipoDocumento"
            value={traerTipoDoc()}
            onChange={handleTipoDocumentoChange}
          >
            {tiposDocumento.map((tipoDeDocumento) => {
              return (
                <option
                  key={tipoDeDocumento.idTipoDocumento}
                  value={tipoDeDocumento.idTipoDocumento}
                >
                  {tipoDeDocumento.sigla}
                </option>
              );
            })}
          </select>
        )}
      </td>
      <td>
        <input
          type="text"
          onChange={handleInputChange}
          name="documento"
          value={pasajeroNuevo.documento}
          placeholder="N&uacute;mero de documento"
          disabled={disabled}
          style={{
            width: "70px",
          }}
        />
      </td>
      <td>
        <input
          type="date"
          name="fechaNacimientoISO"
          placeholder="Fecha Nacimiento"
          onChange={handleInputChange}
          value={pasajeroNuevo.fechaNacimientoISO}
          disabled={disabled}
          style={{
            width: "87px",
          }}
        />
        ({pasajeroNuevo.tipoPasajero})
      </td>
      <td>
        <input
          type="text"
          onChange={handleInputChange}
          name="telefono"
          value={pasajeroNuevo.telefono}
          placeholder="Telefono"
          disabled={disabled}
          style={{
            width: "90px",
          }}
        />
      </td>
      {(tipoCliente !== "IND" || estado !== "2") && ( //estado 2 es si tiene cierre operativo
        <td>
          {disabled && (
            <span
              className="btnEditarPax"
              style={{
                color: "blue",
              }}
              onClick={() => hadleClickEditar(pasajeroNuevo)}
            >
              Editar
            </span>
          )}
          {!disabled && (
            <span
              className="btnEditarPax"
              style={{
                color: "blue",
              }}
              onClick={() =>
                hadleClickGuardar(pasajeroNuevo, pasajero.documento)
              }
            >
              Guardar
            </span>
          )}
          {!disabled && (
            <span
              className="btnEditarPax"
              style={{
                color: "red",
              }}
              onClick={hadleClickCancelar}
            >
              Cancelar
            </span>
          )}
        </td>
      )}
    </tr>
  );
};

export default withRouter(EdicionPasajero);



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ReservaFila/EdicionPasajero.js